import { fetchOldPrices } from "@campgladiator/cg-common.api.prices";
import {
  ContractStatisticDTO,
  SwapType,
  UnlistedPriceDTO,
} from "@campgladiator/cg-common.types.types";

let recommitPrices: UnlistedPriceDTO[] = [];
let oldPrices: UnlistedPriceDTO[] = [];

export const loadUnlistedPrice = async (
  recommitProductDetails: UnlistedPriceDTO[]
) => {
  if (!oldPrices.length) oldPrices = await fetchOldPrices();
  if (!recommitPrices.length) recommitPrices = recommitProductDetails;
};

export const getProperPrice = (
  priceSelection: ContractStatisticDTO["priceSelection"],
  swapType?: SwapType
) => {
  if (swapType === "ROLLOVER") return [];
  switch (priceSelection) {
    case "OLD_PRICE":
      return oldPrices;

    case "RECOMMIT_PRICE":
      return recommitPrices;

    case "NEW_PRICE":
      return [];

    default:
      return [];
  }
};
